import csv from '../assets/csv-icon.png'

export default {
  csv,
}
